import React, { useEffect, useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import ReactDOM from "react-dom";



const ModalInformativo = ({ show, onClose, children, title }) => {
    const [isBrowser, setIsBrowser] = useState(false);

    useEffect(() => {
        setIsBrowser(true);
    }, []);

    const handleCloseClick = (e) => {
        onClose();
    };

    if (isBrowser) {
        return ReactDOM.createPortal(<>
            <Modal show={show} onHide={handleCloseClick}>
                <Modal.Header closeButton>
                    <Modal.Title>Informacion</Modal.Title>
                </Modal.Header>
                <Modal.Body>{children}</Modal.Body>
                <Modal.Footer>
                    <Button style={{ backgroundColor: '#0033A0' }} onClick={handleCloseClick}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>, document.getElementById("modal-root"));
    } else {
        return null
    }



}

export default ModalInformativo;